import { render, staticRenderFns } from "./ProvisionalAuthorization.vue?vue&type=template&id=04e2d848&scoped=true&"
import script from "./ProvisionalAuthorization.vue?vue&type=script&lang=js&"
export * from "./ProvisionalAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionalAuthorization.vue?vue&type=style&index=0&id=04e2d848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2d848",
  null
  
)

export default component.exports